module.exports = {"id":"234935","name":"João Talocha","rating":"72","photo":"./data/images/photos/1/234935.png","club":{"name":"Boavista","logo":"./data/images/clubs/Boavista.png"},"positions":["DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoaoTalocha0.json
// module id = 2038
// module chunks = 0